import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(VTab, [_vm._v("General")]),
                  _c(VTab, [_vm._v("Connections")]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Original")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Organization",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOriginDs.organization,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "organization",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOriginDs.organization",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Database Engine",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objOriginDs.database_engine,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "database_engine",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOriginDs.database_engine",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Data Operator",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOriginDs.data_operator,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "data_operator",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOriginDs.data_operator",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Domain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectDomain,
                                        },
                                        model: {
                                          value: _vm.objOriginDs.kdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "kdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objOriginDs.kdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Subdomain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectSubdomain,
                                        },
                                        model: {
                                          value: _vm.objOriginDs.ksubdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "ksubdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objOriginDs.ksubdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Sensitive Data",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: { size: "sm", disabled: "" },
                                        model: {
                                          value: _vm.objOriginDs.sensitive_data,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "sensitive_data",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOriginDs.sensitive_data",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Environment",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objOriginDs.environment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "environment",
                                              $$v
                                            )
                                          },
                                          expression: "objOriginDs.environment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Description",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        staticClass: "input-mini",
                                        attrs: {
                                          size: "sm",
                                          rows: "3",
                                          "max-rows": "3",
                                          type: "text",
                                          "no-resize": "",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objOriginDs.object_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objOriginDs,
                                              "object_description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objOriginDs.object_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Request")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Organization",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.organization,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequestDs.organization,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "organization",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.organization",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Database Engine",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.database_engine,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objRequestDs.database_engine,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "database_engine",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.database_engine",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Data Operator",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.data_operator,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequestDs.data_operator,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "data_operator",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.data_operator",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Domain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        class: {
                                          resaltador: _vm.diffRequest.kdomain,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectDomain,
                                        },
                                        model: {
                                          value: _vm.objRequestDs.kdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "kdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objRequestDs.kdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Subdomain",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.ksubdomain,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          disabled: "",
                                          options: _vm.selectSubdomain,
                                        },
                                        model: {
                                          value: _vm.objRequestDs.ksubdomain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "ksubdomain",
                                              $$v
                                            )
                                          },
                                          expression: "objRequestDs.ksubdomain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Sensitive Data",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.sensitive_data,
                                        },
                                        attrs: { size: "sm", disabled: "" },
                                        model: {
                                          value:
                                            _vm.objRequestDs.sensitive_data,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "sensitive_data",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.sensitive_data",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Environment",
                                        "label-cols": "4",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.environment,
                                        },
                                        attrs: {
                                          size: "sm",
                                          type: "text",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.objRequestDs.environment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "environment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.environment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "sm",
                                        label: "Description",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        staticClass: "input-mini",
                                        class: {
                                          resaltador:
                                            _vm.diffRequest.object_description,
                                        },
                                        attrs: {
                                          size: "sm",
                                          rows: "3",
                                          "max-rows": "3",
                                          type: "text",
                                          "no-resize": "",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.objRequestDs.object_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.objRequestDs,
                                              "object_description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "objRequestDs.object_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Original")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "filter",
                                        "label-cols": "1",
                                        "label-size": "sm",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { size: "sm" },
                                        model: {
                                          value: _vm.filterOriginDs,
                                          callback: function ($$v) {
                                            _vm.filterOriginDs = $$v
                                          },
                                          expression: "filterOriginDs",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("b-table", {
                                    staticClass: "table-mini",
                                    attrs: {
                                      bordered: "",
                                      striped: "",
                                      responsive: "",
                                      items: _vm.objOriginDs.tables,
                                      fields: _vm.fields,
                                      "show-empty": "",
                                      filter: _vm.filterOriginDs,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Request")]),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "filter",
                                        "label-cols": "1",
                                        "label-size": "sm",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { size: "sm" },
                                        model: {
                                          value: _vm.filterRequestDs,
                                          callback: function ($$v) {
                                            _vm.filterRequestDs = $$v
                                          },
                                          expression: "filterRequestDs",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("b-table", {
                                    key: _vm.keyTableRequest,
                                    staticClass: "table-mini",
                                    attrs: {
                                      bordered: "",
                                      striped: "",
                                      responsive: "",
                                      items: _vm.objRequestDs.tables,
                                      fields: _vm.fields,
                                      "show-empty": "",
                                      filter: _vm.filterRequestDs,
                                      "tbody-tr-class": _vm.rowClass,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Request reason",
                              },
                            },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  filled: "",
                                  dense: "",
                                  size: "sm",
                                  rows: "3",
                                  "max-rows": "3",
                                  type: "text",
                                  "no-resize": "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.item.commentary,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "commentary", $$v)
                                  },
                                  expression: "item.commentary",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showFooter
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "sm",
                                    label: "Message to reply",
                                  },
                                },
                                [
                                  _c(VTextarea, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      size: "sm",
                                      rows: "3",
                                      "max-rows": "3",
                                      type: "text",
                                      "no-resize": "",
                                    },
                                    model: {
                                      value: _vm.response_text,
                                      callback: function ($$v) {
                                        _vm.response_text = $$v
                                      },
                                      expression: "response_text",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                dismissible: "",
                                variant: "danger",
                              },
                              on: {
                                dismissed: function ($event) {
                                  _vm.dismissCountDown = 0
                                },
                                "dismiss-count-down": _vm.countDownChanged,
                              },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                              _c("b-progress", {
                                attrs: {
                                  variant: "danger",
                                  max: _vm.dismissSecs,
                                  value: _vm.dismissCountDown,
                                  height: "4px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }